import React, { useContext } from "react";
import MainTitle from "components/MainTitle";
import { store } from "../../store.js";

const SimplePage = ({
  title,
  children,
}) => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;

  return (
    <>
      <div>
        <MainTitle sm>{title}</MainTitle>
        {children}
      </div>
    </>
  );
};

export default SimplePage;
